import http from "../../components/service";
import userService from "@/services/user";
import { APPLICATION } from "@/components/admin/brand/constant";

export const user = {
    namespaced: true,
    state: {
        roles: {},
        token: null,
        zones: [],
        zoneCurrent: null,
        functionalitiesAccess: null,
        profileAccess: null,
        applicationProfile: null,
        users: [],
        userList: [],
        disconnectingUser: false
    },
    getters: {
        getAllUsers(state) {
            return state.users;
        },

        getAllUsersList(state) {
            return state.userList;
        },

        getRoles(state) {
            return state.roles;
        },
        getAllZones(state) {
            return state.zones;
        },

        getFunctionalitiesAccess(state) {
            return state.functionalitiesAccess;
        },
        getProfileAccess(state) {
            return state.profileAccess;
        },
        getApplicationProfile(state) {
            return state.applicationProfile;
        },
        getDisconnectingUser(state) {
            // return state.disconnectingUser;
        }
    },
    mutations: {
        FIND_ALL_ZONES(state, zones) {
            state.zones = zones;
        },

        FIND_ALL_FUNCTONALITIES_ACCESS(state, res) {
            state.functionalitiesAccess = res;
        },
        FIND_ALL_PROFILE_ACCESS(state, res) {
            state.profileAccess = res;
        },
        FIND_ALL_APPLICATION_PROFILE(state, res) {
            state.applicationProfile = res;
        },
        ADD_NEW_USER(state, user) {
            state.userList.push(user);
        },

        FIND_ALL_USERS(state, res) {
            state.users = res;
        },

        GET_ALL_USERS_LIST_ACTION(state, res) {
            state.userList = res;
        },

        CLEAN_FUNCTONALITIES_ACCESS(state) {
            state.functionalitiesAccess = null;
        },
        DISCONNECTING_USER(state, newVal) {
            console.log(newVal);
        }
    },
    actions: {
        getAllUsersListAction(context, checked) {
            return http
                .get("/admin/manager/user/list?limit=1000&" + (checked.checkedUsers ? "active=1&" : "") + (checked.checkedBrands ? "all=1&" : ""))
                .then(response => {
                    if (response.code && response.code !== 200) {
                        window.location.href = "/error" + (response.code === 403 ? response.code : "404");
                    } else {
                        let dataList = response.data.map(v => {
                            return {
                                ...v,
                                ...{
                                    fullName: v.firstname + " " + v.lastname,
                                    name: v.firstname + " " + v.lastname
                                }
                            };
                        });
                        context.commit("GET_ALL_USERS_LIST_ACTION", dataList);
                        return dataList;
                    }
                });
        },

        async create({ commit }, user) {
            const res = await userService.create(user);
            const map = {
                gender: res.gender,
                fullName: res.firstname + " " + res.lastname,
                isSuperAdmin: res.isSuperAdmin,
                userType: res.userType,
                id: res.id,
                firstname: res.firstname,
                lastname: res.lastname,
                email: res.email,
                userBrand: res.userBrand,
                isEnabled: res.isEnabled,
                isSsoEnabled: res.isSsoEnabled
            };
            commit("ADD_NEW_USER", map);
            return map;
        },

        async findAllZones(context, active = "yes") {
            return http.get("/admin/all/zones?is_active=" + active).then(res => {
                if (http.hasError(res)) {
                    alert(res.message);
                    return null;
                } else {
                    context.commit("FIND_ALL_ZONES", res);
                    return res;
                }
            });
        },

        async findAllUsers(context) {
            return http.get("/admin/users?limit=1000").then(res => {
                if (http.hasError(res)) {
                    alert(res.message);
                    return null;
                } else {
                    context.commit("FIND_ALL_USERS", res);
                    return res;
                }
            });
        },

        async findAllFunctionalitiesAccess(context, id) {
            return http.get("/admin/users/" + id).then(res => {
                if (http.hasError(res)) {
                    window.location.href = "/error404";
                    return null;
                } else {
                    context.commit("FIND_ALL_FUNCTONALITIES_ACCESS", res);
                    return res;
                }
            });
        },
        async findAllProfileAccess(context, data) {
            if (!data.appId) {
                data.appId = APPLICATION.FORECAST_ID;
            }
            return http.get("/" + data.appId + "/admin/users/" + data.id + "/profiles").then(res => {
                if (http.hasError(res)) {
                    window.location.href = "/error404";
                    return null;
                } else {
                    context.commit("FIND_ALL_PROFILE_ACCESS", res);
                    return res;
                }
            });
        },
        async findAllApplicationProfile(context, data) {
            return http.get("/admin/application-has-profiles").then(res => {
                if (http.hasError(res)) {
                    window.location.href = "/error404";
                    return null;
                } else {
                    context.commit("FIND_ALL_APPLICATION_PROFILE", res);
                    return res;
                }
            });
        },
        cleanFunctionalitiesAccess(context) {
            context.commit("CLEAN_FUNCTONALITIES_ACCESS");
        },
        setDisconnectingUser(context, data) {
            context.commit("DISCONNECTING_USER", val);
        }
    }
};



// WEBPACK FOOTER //
// ./src/store/user/user.js